var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "code-entry-form-ui",
      attrs: { autocomplete: "off" },
      on: {
        submit: function($event) {
          $event.preventDefault()
        }
      }
    },
    [
      _vm.showLoader || _vm.showLoaderResendSms
        ? _c("LoaderUI", {
            staticClass: "bg-white",
            attrs: { modify: _vm.showLoader ? "absolute" : "" }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.showLoaderResendSms
        ? _c("GroupInputCodeUI", { on: { "update-code": _vm.updateCode } })
        : _vm._e(),
      _vm._v(" "),
      _vm.textServerErrors
        ? _c("div", { staticClass: "server-error-ui txt-center" }, [
            _vm._v("\n    " + _vm._s(_vm.textServerErrors) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "code-entry-form-ui__footer" },
        [
          _vm.resendTime
            ? _c(
                "div",
                {
                  staticClass:
                    "code-entry-form-ui__resend-time txt-s txt-disabled txt-center"
                },
                [
                  _vm._v("\n      " + _vm._s(_vm.btnTitle) + "\n\n      "),
                  _c("countdown", {
                    attrs: {
                      time: _vm.resendTime,
                      transform: _vm.transformCountdown
                    },
                    on: {
                      end: function($event) {
                        _vm.resendTime = null
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(props) {
                            return [
                              _vm._v(
                                "\n          (" +
                                  _vm._s(props.minutes) +
                                  ":" +
                                  _vm._s(props.seconds) +
                                  ")\n        "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2142816433
                    )
                  })
                ],
                1
              )
            : [
                _c(
                  "button",
                  {
                    staticClass:
                      "code-entry-form-ui__btn btn-ui btn-ui--full btn-ui--secondary",
                    attrs: { type: "button", disabled: _vm.processExecute },
                    on: { click: _vm.sendNewCode }
                  },
                  [
                    _vm._v("\n        " + _vm._s(_vm.btnTitle) + "\n        "),
                    _vm.processExecute
                      ? _c("LoaderUI", {
                          staticClass: "code-entry-form-ui__loader",
                          attrs: { modify: "xxs" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
          _vm._v(" "),
          _c("CaptchaUI", {
            ref: "recaptcha",
            on: {
              verify: _vm.submitForResendCode,
              expired: _vm.onCaptchaExpired,
              render: _vm.onRenderRecaptcha,
              "process-execute": _vm.setProcessExecute
            }
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }